(() => {
  function initialize(root) {
    if (root.classList.contains('is-enhanced')) return;
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[data-drop-panel]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      root.querySelectorAll("[data-drop-collection]").forEach(link => { link.href = panels[index].dataset.collectionUrl; });
      if (focus) tabs[index].focus();
    };
    panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs[index].id);
      // The server renders at most four distinct designs. Colour variants live in swatches.
    });
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    select(0);
    root.classList.add('is-enhanced');
    root.querySelector('[role="tablist"]').hidden = false;
  }
  document.querySelectorAll('[data-new-drop]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-new-drop]').forEach(initialize);
  });
})();
